import { useEffect, useRef, useState } from "react";

const Counter = ({ target = 0, suffix = "", duration = 8000 }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    let started = false;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started) {
        started = true;

        const steps = 200;
        const increment = target / steps;
        const intervalTime = duration / steps;

        let current = 0;

        const timer = setInterval(() => {
          current += increment;

          if (current >= target) {
            setCount(target);
            clearInterval(timer);
          } else {
            setCount(Math.floor(current));
          }
        }, intervalTime);
      }
    });

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [target, duration]);

  return (
    <span ref={ref}>
      {count}
      {suffix}
    </span>
  );
};

export default Counter;
